import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'process-item',
  templateUrl: './process-item.component.html',
  styleUrls: ['./process-item.component.scss']
})
export class ProcessItemComponent implements OnInit {

  /*
   * team is a attribute.
   */
  @Input() item : any;
  @Input() number : any;
  @Input() state : any = 0 ;
  @Input() width : any = 0 ;
  /*
   * route is a attribute.
   * This is get the page url.
   */

  constructor(public router: Router) {
  }

  ngOnInit() {
  }


}
